/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userBusinessBanners.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Business banners. Used to display promotional material.
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class UserBusinessBannersModel(
    /** Contains business data */
    @SerialName("data")
    val data: BusinessData?,

    /** Contains all A la carte items */
    @SerialName("included")
    val included: UserBusinessBannersIncluded?
) : Model()
